import { useState } from "react";
import { useTranslation } from "react-i18next";
import { newsItems } from "@/mocks/home";

export default function News() {
  const { t } = useTranslation();
  const [activeId, setActiveId] = useState(newsItems[0].id);

  const active = newsItems.find((item) => item.id === activeId) ?? newsItems[0];

  return (
    <section id="news" className="w-full bg-background-100 py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-2xl mb-10 md:mb-14">
          <div className="flex items-center gap-3 mb-5">
            <span className="h-px w-10 bg-primary-400"></span>
            <span className="font-label text-sm uppercase tracking-[0.3em] text-primary-600">
              {t("news.kicker")}
            </span>
          </div>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950">
            {t("news.title")}
          </h2>
          <p className="mt-4 text-base leading-relaxed text-foreground-600">
            {t("news.subtitle")}
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
          <div className="lg:col-span-5 flex flex-col divide-y divide-background-200 border-t border-b border-background-200">
            {newsItems.map((item) => {
              const isActive = item.id === activeId;
              return (
                <button
                  key={item.id}
                  type="button"
                  onClick={() => setActiveId(item.id)}
                  className={`group text-left py-5 px-4 border-l-2 transition-colors cursor-pointer ${
                    isActive
                      ? "border-primary-500 bg-background-50"
                      : "border-transparent hover:bg-background-50/70"
                  }`}
                >
                  <div className="flex items-center gap-3 mb-2">
                    <span className="font-label text-xs uppercase tracking-[0.16em] text-primary-600">
                      {item.category}
                    </span>
                    <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
                    <span className="font-label text-xs uppercase tracking-[0.16em] text-foreground-400">
                      {item.date}
                    </span>
                  </div>
                  <h3
                    className={`font-heading text-lg md:text-xl font-semibold transition-colors ${
                      isActive
                        ? "text-foreground-950"
                        : "text-foreground-700 group-hover:text-foreground-950"
                    }`}
                  >
                    {item.title}
                  </h3>
                </button>
              );
            })}
          </div>

          <div className="lg:col-span-7">
            <div className="h-full rounded-lg border border-background-200 bg-background-50 overflow-hidden">
              <div className="h-36 md:h-44 bg-gradient-to-br from-secondary-800 to-secondary-950 p-6 md:p-8 flex flex-col justify-end">
                <span className="font-label text-xs uppercase tracking-[0.2em] text-secondary-200">
                  {active.category}
                </span>
                <h3 className="font-heading text-2xl md:text-4xl font-bold text-background-50 mt-1">
                  {active.title}
                </h3>
              </div>
              <div className="p-6 md:p-8">
                <p className="font-label text-xs uppercase tracking-[0.18em] text-foreground-400">
                  {active.date}
                </p>
                <p className="mt-5 text-base leading-relaxed text-foreground-700">
                  {active.excerpt}
                </p>
                <a
                  href="#contact"
                  className="mt-7 inline-flex items-center gap-2 font-label text-sm uppercase tracking-[0.16em] text-primary-700 hover:text-primary-600 cursor-pointer"
                >
                  {t("news.readMore")}
                  <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}